import { CancelToken } from 'axios'
import apiInstance from '../../../backend-api.setup'

const getPrivateReportsNextService = (
  path: string,
  cancelToken?: CancelToken,
) => {
  const url = new URL(path)
  return apiInstance.get(url.pathname + url.search, {
    cancelToken,
  })
}

export default getPrivateReportsNextService
